import React from 'react';
import Time from 'react-time';
import { ClockIcon } from '../icons/ClockIcon.jsx';

const DateRangeDisplay = ({ startDate, endDate, label = 'Dates' }) => (
  <div className="flex header-item">
    <ClockIcon />
    <strong className="text-muted m-r-12 m-l-8">{label}: </strong>
    {startDate && endDate ? (
      <React.Fragment>
        <strong>
          <Time value={startDate} format="M/D/YY" />
        </strong>
        <strong>
          <span>&nbsp;- </span>
          <Time value={endDate} format="M/D/YY" />
        </strong>
      </React.Fragment>
    ) : (
      '—'
    )}
  </div>
);

export default DateRangeDisplay;
